import React from 'react'

const MailIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    fill="none"
    viewBox="0 0 22 22"
    {...props}
  >
    <path
      fill="#000"
      fillRule="evenodd"
      d="M.264 4.768l10.703 6.18 10.755-6.21A3 3 0 0019 3H3A3 3 0 00.264 4.768zM22 6.887l-10.56 6.096a1 1 0 01-1.183-.136L0 6.925V16a3 3 0 003 3h16a3 3 0 003-3V6.887z"
      clipRule="evenodd"
    ></path>
  </svg>
)

export default MailIcon
